<template>
    <div class="detail" :key="keyIndex">
        <div class="detail-bd">
            <div id="main-player" class="video-player"></div>
            <div class="video-info">
                <div class="video-head">
                    <div v-if="detail.vipShowFlag" class="vip">VIP</div>
                    <h4>{{detail.name}}</h4>
                    <div class="line-count">共{{otherItems.length}}条路线</div>
                </div>
                <div class="video-all">
                    <div v-for="(item) in otherItems" :key="item.id" class="item" :class="{active: item.selectFlag}" @click="jumpPage(item.id)">{{item.name}}</div>
                </div>
                <div class="intro">{{detail.brief}}</div>
                <div class="count">
                    <div class="eye"><van-icon class="icon" name="eye-o" />{{detail.clickRate}}</div>
                    <div class="nice"><van-icon class="icon" name="good-job-o" />{{detail.likeNum}}</div>
                </div>
            </div>
            <div class="recommend">
                <h4>推荐视频</h4>
                <div class="wrap">
                    <div v-for="(item) in recommendList" :key="item.id" class="item" @click="jumpPage(item.id)">
                        <div class="thumbnail">
                            <img :src="item.coverUrl">
                            <div class="play"><van-icon name="play-circle-o" /></div>
                            <div v-if="detail.vipFlag" class="vip">VIP</div>
                            <div class="time">{{formatSeconds(item.duration)}}</div>
                        </div>
                        <div class="name">{{item.name}}</div>
                        <div class="count">
                            <div class="eye"><van-icon class="icon" name="eye-o" />{{item.clickRate}}</div>
                            <div class="nice"><van-icon class="icon" name="good-job-o" />{{item.likeNum}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Icon } from 'vant'
import { formatSeconds } from '../../../utils'

export default {
    name: 'vipCoachGoodsVideoDetail',
    components: {
        [Icon.name]: Icon,
    },
    data () {
        return {
            keyIndex: Date.now(),
            detailId: '',
            detail: {},
            erConfigDTO: {},
            otherItems: [],
            recommendList: [],
            placeInfo: {}
        }
    },
    methods: {
        formatSeconds,
        // 查询视频详情
        getDetail () {
            this.$api.videoDetailV2({
                id: this.detailId
            }).then(res => {
                if (res.status) {
                    const {examPlaceName, examPlaceBatchId, routeList, recommendList} = res.result
                    this.otherItems = routeList
                    this.recommendList = recommendList
                    this.detail = routeList.find(({ selectFlag }) => (selectFlag))
                    this.placeInfo = {
                        examPlaceName, examPlaceBatchId, cityCode: this.$route.query.cityCode
                    }
                    this.$nextTick(() => {
                        this.init()
                    })
                }
            })
        },
        // 设置播放
        init () {
            const template = [
                '<div class="preview-video">',
                    '<div class="title">试看结束</div>',
                    '<div class="close">X</div>',
                '</div>'
            ]
            new window.Aliplayer({
                id: 'main-player',
                vid: this.detail.vid,
                playauth: this.detail.playAuth,
                qualitySort: 'asc',
                format: 'mp4',
                mediaType: 'video',
                autoplay: false,
                isLive: false,
                rePlay: false,
                playsinline: true,
                preload: false,
                useH5Prism: true,
                components: [{
                    name: 'PreviewVodComponent',
                    type: window.AliPlayerComponent.PreviewVodComponent,
                    args: [this.detail.durationVip, template.join('')]
                }],
                skinLayout: [
                    {
                        name: 'bigPlayButton',
                        align: 'blabs',
                        x: 30,
                        y: 80
                    },
                    {
                        name: 'H5Loading',
                        align: 'cc'
                    },
                    {
                        name: 'errorDisplay',
                        align: 'tlabs',
                        x: 0,
                        y: 0
                    },
                    {
                        name: 'infoDisplay'
                    },
                    {
                        name: 'tooltip',
                        align: 'blabs',
                        x: 0,
                        y: 56
                    },
                    {
                        name: 'controlBar',
                        align: 'blabs',
                        x: 0,
                        y: 0,
                        children: [
                            {
                                name: 'progress',
                                align: 'blabs',
                                x: 0,
                                y: 44
                            },
                            {
                                name: 'playButton',
                                align: 'tl',
                                x: 15,
                                y: 12
                            },
                            {
                                name: 'timeDisplay',
                                align: 'tl',
                                x: 10,
                                y: 7
                            },
                            {
                                name: 'setting',
                                align: 'tr',
                                x: 15,
                                y: 12
                            },
                            {
                                name: 'volume',
                                align: 'tr',
                                x: 5,
                                y: 10
                            }
                        ]
                    }
                ]
            }, (player) => {
                // 关闭试看
                const close = document.querySelector('.preview-video .close')
                close.addEventListener('click', () => {
                    player.getComponent('PreviewVodComponent').closePreviewLayer()
                })
            })
        },
        jumpPage (id) {
            if (this.detailId !== id) {
                this.keyIndex = Date.now()
                this.detailId = id
                this.getDetail()
            }
        },
        handleBeforeClick () {
            window.aplus_queue.push({
                action: 'aplus.record',
                arguments: ['e_ervip_video_button_click', 'CLK', {}]
            })
        }
    },
    mounted () {
        this.detailId = this.$route.query.id
        this.getDetail()
    }
}
</script>
<style lang="scss">
.preview-custom{
    display: flex;
    align-items: center;
    justify-content: center;
}
.prism-player .prism-info-display{
    display: none;
}
.prism-player .prism-big-play-btn{
    z-index: 98;
    left: 50% !important;
    top: 50% !important;
    width: 32px;
    height: 32px;
    transform: translate(-50%, -50%);
    .outter{
        width: 100%;
        height: 100%;
    }
}
.preview-vod-component .preview-component-layer,
.preview-vod-component .preview-component-tip{
    z-index: 99;
}
.preview-video{
    text-align: center;
    .title{
        margin-top: 30px;
        color:#fff;
        font-size: 22px;
        font-weight: 600;
    }
    .btn{
        margin-top: 20px;
        padding: 8px 16px;
        font-size: 16px;
        background: linear-gradient(90deg, #F8AB59 0%, #FD8435 100%);
        border-radius: 15px;
    }
    .close {
        margin: 20px auto 0 auto;
        width: 24px;
        height: 24px;
        line-height: 28px;
        border-radius: 50%;
        background-color: rgba(255,255,255,0.5);
    }
}
.preview-custom-bar, .preview-vod-close {
    display: none;
}
</style>
<style lang="scss" scoped>
* {
    box-sizing: border-box;
}
.detail{
    display: flex;
    flex-direction: column;
    color:#333;
    font-size: 14px;
    line-height: 1;
    height: 100vh;
    background: #FAFAFA;
    .detail-bd{
        flex: 1;
        height: 0;
        overflow: auto;
    }
    .video-player{
        height: 210px;
        background-color: #000;
    }
    .video-info{
        padding: 20px 16px;
        background-color: #fff;
        h4{
            font-size: 18px;
        }
        .intro{
            margin-top: 10px;
            font-size: 13px;
            line-height: 24px;
        }
        .count{
            margin-top: 12px;
            display: flex;
            align-items: center;
            color: #999999;
            font-size: 13px;
            &>div{
                display: flex;
                align-items: center;
                margin-right: 21px;
                font-size: 14px;
                .icon{
                    margin-top: -2px;
                    margin-right: 5px;
                    font-size: 24px;
                }
            }
        }
    }
    .video-head{
        display: flex;
        .vip{
            margin-right: 8px;
            text-align: center;
            width: 34px;
            padding: 2.5px 0;
            color: #FFFFFF;
            font-size: 13px;
            font-weight: 500;
            letter-spacing: 2px;
            background: linear-gradient(134deg, #F5DDB6 0%, #EAC285 100%);
            border-radius: 2px;
        }
        h4 {
            flex: 1;
        }
        .line-count {
            color: #FF6F04;
            font-size: 13px;
        }
    }
    .video-all{
        display: flex;
        margin-top: 12px;
        overflow: scroll;
        flex-wrap: nowrap;
        white-space: nowrap;
        .item{
            margin-right: 5px;
            padding: 8px;
            color: #666666;
            font-weight: 400;
            background: #F4F4F4;
            border-radius: 5px;
            text-align: center;
            border: 1px solid #F4F4F4;

            &.active{
                color: #FF6F04;
                border-color: #FF6F04;
                background-color: #FEECDE;
            }
        }
    }
    .recommend{
        margin-top: 12px;
        padding: 20px 10px;
        background-color: #fff;
        h4{
            padding-left: 10px;
            font-size: 16px;
            font-weight: 600;
            border-left: 3px solid #53CB85;
        }
        .wrap{
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding: 20px 13px 0;
            .item{
                margin-bottom: 30px;
                flex: 0 0 155px;
                width: 0;
                .thumbnail{
                    position: relative;
                    height: 100px;
                    overflow: hidden;
                    border-radius: 5px;
                    &::before{
                        content:'';
                        position: absolute;
                        top:0;
                        left:0;
                        width: 100%;
                        height: 100%;
                        background-color: rgba(0,0,0,0.2);
                    }
                    img{
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                    .vip{
                        position: absolute;
                        top:0;
                        right: 5px;
                        width: 32px;
                        height: 14px;
                        line-height: 14px;
                        color:#fff;
                        font-size: 12px;
                        background: #E0B763;
                        border-radius: 0 0 2px 2px;
                        text-align: center;
                    }
                    .info, .play{
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        height: 21px;
                        transform: translate(-50%, -50%);
                        color: #fff;
                        font-size: 21px;
                    }
                    .time{
                        position: absolute;
                        bottom: 5px;
                        right: 5px;
                        color: #fff;
                        font-size: 13px;
                    }
                }
                .name{
                    margin-top: 15px;
                    font-size: 15px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .count{
                    margin-top: 12px;
                    display: flex;
                    align-items: center;
                    color: #999999;
                    font-size: 13px;
                    &>div{
                        display: flex;
                        align-items: center;
                        margin-right: 21px;
                        font-size: 13px;
                        .icon{
                            margin-right: 5px;
                        }
                    }
                }
            }
        }
    }
}
</style>
